import { Doctor } from '@/domain/entities/Doctor';
import { IDoctor } from '@/domain/IDoctor';
import { db } from '@/infraestructure/datasource';


export class DoctorRepository implements IDoctor {

    _db: typeof db;

    constructor() {
        this._db = db;
    }

    static get key() { return  'DoctorRepository' }

    async fetchUserData(userId: string): Promise<Doctor> {
        let doctorDoc = await db.collection('doctors').doc(userId).get()
        let doctorData = doctorDoc.data()
        doctorData!.id = doctorDoc.id
        let d = doctorData as Doctor
        return d
    }
}